import { render, staticRenderFns } from "./LkHomeIndex.vue?vue&type=template&id=4b9635c2&"
import script from "./LkHomeIndex.vue?vue&type=script&lang=js&"
export * from "./LkHomeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports